import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

export default function Footer() {
  return (
    <div className="container-fluid bg-dark text-white py-3">
      <div className="row">
        <div className="col-12 col-md-4 text-start">
          <h5>Contact Us</h5>
          <p>Holy Family Catholic Church</p>
          <p>6032 Normandy Drive</p>
          <p>Halifax, NS, B3K 2S9</p>
          <p><a href="tel: +1-306-510-7700">+1-306-510-7700 - Vicar</a></p>
          <p><a href="tel: +1-902-412-1903">+1-902 412 1903 - Parish Trustee</a></p>
          <p><a href="tel: +1-902-452-0003">+1-902 452 0003 - Parish Trustee</a></p>
        </div>
        <div className="col-12 col-md-4 d-none d-md-block">
          <h5>Quick Links</h5>
          <ul className="list-unstyled">
            <li><Link to="/history" className="text-white">History</Link></li>
            <li><Link to="/services" className="text-white">Services</Link></li>
            <li><Link to="/committee" className="text-white">Committee</Link></li>
            <li><Link to="/gallery" className="text-white">Gallery</Link></li>
            <li><Link to="/catechism" className="text-white">Catechism</Link></li>
            <li><Link to="/forms" className="text-white">Forms</Link></li>
          </ul>
        </div>
        <div className="col-12 col-md-4 mb-4">
          <h5>Follow Us</h5>
          <a href="https://www.facebook.com/groups/1003089003043538" target="_blank" rel="noreferrer" className="text-white me-3">
            <FacebookIcon />
          </a>
          <a href="https://www.instagram.com/syrohalifax/" target="_blank" rel="noreferrer" className="text-white me-3">
            <InstagramIcon />
          </a>
          <a href="https://www.youtube.com/@holyfamilysyromalabarcatho8797" target="_blank" rel="noreferrer" className="text-white">
            <YouTubeIcon />
          </a>
        </div>
      </div>
      <div>
        <p className="text-center">&copy; 2025 Holy Family Syro-Malabar Catholic Church, Halifax</p>
      </div>
    </div>
  );
}
